export default "__VITE_ASSET__DVs0cLIc__"